import { Component, ContentChild, Input, OnInit } from '@angular/core';
import { SurveyListing } from '../../services/buyer-api/survey.interface';
import { LocaleData, LocaleDataMapper } from './domain/locale-data-mapper';
import { EachCountry } from '../../interfaces/common-service.interface';
import { CountryViewableCellContentDirective } from './directives/country-viewable-cell-content.directive';
import { CountryHoverableCellContentDirective } from './directives/country-hoverable-cell-content.directive';
import { BuyerSurveyResponse } from '@purespectrum1/ui/marketplace/shared/interfaces/survey.interface';
import { DashboardSurveyTransform } from '../../../dashboard/domain/dashboard-survey-transform';
import { AuthService } from '../../../auth/auth.service';

@Component({
  selector: 'ps-country-cell-view',
  templateUrl: './country-cell-view.component.html',
  styleUrls: ['./country-cell-view.component.css'],
})
export class CountryCellViewComponent implements OnInit {
  @Input()
  public set survey(data: SurveyListing) {
    this._survey = data;
  }

  @Input()
  public set surveyResponse(data: BuyerSurveyResponse) {
    const [mappedSurvey] = new DashboardSurveyTransform(
      [data],
      this._auth.userType,
      []
    ).listing();
    this._survey = mappedSurvey;
  }

  @Input()
  public countries: EachCountry[] = [];

  @ContentChild(CountryViewableCellContentDirective)
  public viewable?: CountryViewableCellContentDirective;

  @ContentChild(CountryHoverableCellContentDirective)
  public hoverable?: CountryHoverableCellContentDirective;

  public localeData: LocaleData[] = [];
  public hovered = false;

  private _survey = <SurveyListing>{};

  constructor(private _auth: AuthService) {}

  ngOnInit(): void {
    this.localeData = new LocaleDataMapper(this._survey, this.countries).map();
  }
}
